import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const blogData = [
  {
    id: 1,
    img: "/assets/images/blog/post/blog-post-01.png",
    tag: "Company",
    title: "Factories technologies in interactive and plants",
  },
  {
    id: 2,
    img: "assets/images/blog/post/blog-post-02.png",
    tag: "Oil Factory",
    title: "Factories technologies in interactive and plants",
  },
  {
    id: 3,
    img: "assets/images/blog/post/blog-post-03.png",
    tag: "Manufacture",
    title: "Factories technologies in interactive and plants",
  },
  {
    id: 4,
    img: "assets/images/blog/post/blog-post-04.png",
    tag: "Industry",
    title: "Building resilient supply for industries and factorie",
  },
  {
    id: 5,
    img: "assets/images/blog/post/blog-post-01.png",
    tag: "Manufacture",
    title: "Construction of Link new high tech plant in Washington",
  },
  {
    id: 6,
    img: "assets/images/blog/post/blog-post-02.png",
    tag: "Oil Factory",
    title: "Interactive technologies in factories and plants",
  },
];

const Blog = () => {
  
  return (
    <>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">News & Media</h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>News & Media</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rs-postbox-area section-space">
        <div className="container">
          <div className="rs-postbox-wrapper">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <article className="rs-postbox-item">
                  <div className="rs-postbox-thumb">
                    <Link to="#">
                      <img
                        src="/assets/images/blog/post/blog-post-01.png"
                        alt=""
                      />
                    </Link>
                    <div className="rs-postbox-tag">
                      <Link to="#">Company</Link>
                    </div>
                  </div>
                  <div className="rs-postbox-content">
                    <div className="rs-postbox-meta-list">
                      <span>
                        By <Link to="#">Industrie</Link>
                      </span>
                      <span>
                        <Link to="#">June 12, 2023</Link>
                      </span>
                    </div>
                    <h3 className="fs-2">
                      <Link to="#">
                        Factories technologies in interactive and plants
                      </Link>
                    </h3>
                    <p>Industry’s standard dummy text ever since...</p>
                  </div>

                  <div className="rs-postbox-btn">
                    <Link
                      className="rs-btn has-theme-orange has-icon has-bg"
                      to="/news-media-details"
                    >
                      Continue Reading
                      <span className="icon-box">
                        <FiArrowRight />
                      </span>
                    </Link>
                  </div>
                </article>
              </div>

              <div className="col-lg-4 col-md-6">
                <article className="rs-postbox-item">
                  <div className="rs-postbox-thumb">
                    <Link to="#">
                      <img
                        src="assets/images/blog/post/blog-post-02.png"
                        alt=""
                      />
                    </Link>
                    <div className="rs-postbox-tag">
                      <Link to="#">Oil Factory</Link>
                    </div>
                  </div>
                  <div className="rs-postbox-content">
                    <div className="rs-postbox-meta-list">
                      <span>
                        By <Link to="#">Industrie</Link>
                      </span>
                      <span>
                        <Link to="#">June 12, 2023</Link>
                      </span>
                    </div>
                    <h3 className="fs-2">
                      <Link to="#">
                        Factories technologies in interactive and plants
                      </Link>
                    </h3>
                    <p>Industry’s standard dummy text ever since...</p>
                  </div>

                  <div className="rs-postbox-btn">
                    <Link
                      className="rs-btn has-theme-orange has-icon has-bg"
                      to="/news-media-details"
                    >
                      Continue Reading
                      <span className="icon-box">
                        <FiArrowRight />
                      </span>
                    </Link>
                  </div>
                </article>
              </div>

              <div className="col-lg-4 col-md-6">
                <article className="rs-postbox-item">
                  <div className="rs-postbox-thumb">
                    <Link to="#">
                      <img
                        src="assets/images/blog/post/blog-post-03.png"
                        alt=""
                      />
                    </Link>
                    <div className="rs-postbox-tag">
                      <Link to="#">Manufacture</Link>
                    </div>
                  </div>
                  <div className="rs-postbox-content">
                    <div className="rs-postbox-meta-list">
                      <span>
                        By <Link to="#">Industrie</Link>
                      </span>
                      <span>
                        <Link to="#">June 12, 2023</Link>
                      </span>
                    </div>
                    <h3 className="fs-2">
                      <Link to="#">
                        Factories technologies in interactive and plants
                      </Link>
                    </h3>
                    <p>Industry’s standard dummy text ever since...</p>
                  </div>

                  <div className="rs-postbox-btn">
                    <Link
                      className="rs-btn has-theme-orange has-icon has-bg"
                      to="/news-media-details"
                    >
                      Continue Reading
                      <span className="icon-box">
                        <FiArrowRight />
                      </span>
                    </Link>
                  </div>
                </article>
              </div>

              <div className="col-lg-4 col-md-6">
                <article className="rs-postbox-item">
                  <div className="rs-postbox-thumb">
                    <Link to="#">
                      <img
                        src="assets/images/blog/post/blog-post-04.png"
                        alt=""
                      />
                    </Link>
                    <div className="rs-postbox-tag">
                      <Link to="#">Industry</Link>
                    </div>
                  </div>
                  <div className="rs-postbox-content">
                    <h3 className="fs-2">
                      <Link to="#">
                        Building resilient supply for industries and factorie
                      </Link>
                    </h3>
                    <p>Industry’s standard dummy text ever since...</p>
                  </div>
                  <div className="rs-postbox-btn">
                    <Link
                      className="rs-btn has-theme-orange has-icon has-bg"
                      to="/news-media-details"
                    >
                      Continue Reading
                      <span className="icon-box">
                        <FiArrowRight />
                      </span>
                    </Link>
                  </div>
                </article>
              </div>

              <div className="col-lg-4 col-md-6">
                <article className="rs-postbox-item">
                  <div className="rs-postbox-thumb">
                    <Link to="#">
                      <img
                        src="assets/images/blog/post/blog-post-01.png"
                        alt=""
                      />
                    </Link>
                    <div className="rs-postbox-tag">
                      <Link to="#">Manufacture</Link>
                    </div>
                  </div>
                  <div className="rs-postbox-content">
                    <h3 className="fs-2">
                      <Link to="#">
                        Construction of Link new high tech plant in Washington
                      </Link>
                    </h3>
                    <p>Industry’s standard dummy text ever since...</p>
                  </div>

                  <div className="rs-postbox-btn">
                    <Link
                      className="rs-btn has-theme-orange has-icon has-bg"
                      to="/news-media-details"
                    >
                      Continue Reading
                      <span className="icon-box">
                        <FiArrowRight />
                      </span>
                    </Link>
                  </div>
                </article>
              </div>

              <div className="col-lg-4 col-md-6">
                <article className="rs-postbox-item">
                  <div className="rs-postbox-thumb">
                    <Link to="#">
                      <img
                        src="assets/images/blog/post/blog-post-02.png"
                        alt=""
                      />
                    </Link>
                    <div className="rs-postbox-tag">
                      <Link to="#">Oil Factory</Link>
                    </div>
                  </div>
                  <div className="rs-postbox-content">
                    <h3 className="fs-2">
                      <Link to="#">
                        Interactive technologies in factories and plants
                      </Link>
                    </h3>
                    <p>Industry’s standard dummy text ever since...</p>
                  </div>

                  <div className="rs-postbox-btn">
                    <Link
                      className="rs-btn has-theme-orange has-icon has-bg"
                      to="/news-media-details"
                    >
                      Continue Reading
                      <span className="icon-box">
                        <FiArrowRight />
                      </span>
                    </Link>
                  </div>
                </article>
              </div>
            </div>
          </div>

          {/* pagination */}
          <div className="row">
            <div className="col-xl-6">
              <div className="pagination-wrapper mt-40">
                <div className="common-pagination text-start">
                  <nav>
                    <ul>
                      <li>
                        <Link className="current">1</Link>
                      </li>
                      <li>
                        <Link to="#">2</Link>
                      </li>
                      <li>
                        <Link to="#">3</Link>
                      </li>
                      <li>
                        <Link to="#">→</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
